// Display formatters. All are null-tolerant and return "—" (or "#") for empty
// input so callers can pass view columns straight through.

/**
 * $1,234.56 — negatives render as -$1,234.56 (color styling is the caller's
 * job via a class like "red", not this function's). Accepts numeric strings
 * because PostgREST can serialize numeric columns as strings.
 */
export function money(n: number | string | null | undefined): string {
  const v = typeof n === "string" ? Number(n) : n;
  if (v == null || Number.isNaN(v)) return "—";
  const abs = Math.abs(v).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${v < 0 ? "-" : ""}$${abs}`;
}

/** +12125551234 → (212) 555-1234; anything non-NANP renders as-is. */
export function phoneDisplay(e164: string | null | undefined): string {
  if (!e164) return "—";
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164.trim());
  if (m) return `(${m[1]}) ${m[2]}-${m[3]}`;
  return e164;
}

export function telHref(e164: string | null | undefined): string {
  return e164 ? `tel:${e164}` : "#";
}

export function smsHref(e164: string | null | undefined): string {
  return e164 ? `sms:${e164}` : "#";
}

export function mailtoHref(email: string | null | undefined): string {
  return email ? `mailto:${email}` : "#";
}
